const PRODUCTION_HOSTNAMES = ['mytassel.com', 'www.mytassel.com', 'my-tassel.web.app', 'my-tassel.firebaseapp.com'];
const STAGING_HOSTNAMES = ['mytassel-staging.web.app', 'mytassel-staging.firebaseapp.com'];

class StripeConfigService {
  constructor() {
    this.listeners = new Set();
    this.environment = this._detectEnvironment();
    console.log(`🔑 Stripe environment detected: ${this.environment}`);
  }

  _detectEnvironment() {
    try {
      const hostname = window?.location?.hostname || '';
      if (PRODUCTION_HOSTNAMES.includes(hostname)) return 'production';
      if (STAGING_HOSTNAMES.includes(hostname)) return 'staging';
      return 'development';
    } catch {
      return 'development';
    }
  }

  isProduction() {
    return this.environment === 'production';
  }

  isStaging() {
    return this.environment === 'staging';
  }

  // Dev = test, Staging + Production = live. No overrides.
  getStripeMode() {
    const mode = (this.isProduction() || this.isStaging()) ? 'live' : 'test';
    return Promise.resolve(mode);
  }

  isEnvironmentLocked() {
    return true;
  }

  async getPublishableKey() {
    const mode = await this.getStripeMode();
    const keys = {
      test: process.env.REACT_APP_STRIPE_PERSH_TEST_KEY,
      live: process.env.REACT_APP_STRIPE_PERSH_KEY,
    };
    return keys[mode];
  }

  addChangeListener(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  notifyListeners() {
    this.listeners.forEach(cb => { try { cb(); } catch {} });
  }
}

export const stripeConfigService = new StripeConfigService();
export default stripeConfigService;
